<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex align-center">
        <h1>Verification Runs</h1>
        <v-spacer />
        <v-btn color="primary" depressed to="/verification/runs/new">
          New Run
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8">
        <p v-if="!sampleRuns.length" class="grey--text">
          No verification runs yet. Click "New Run" to sample a period.
        </p>
        <SampleRunCard
          v-for="run in sampleRuns"
          :key="run.id"
          :run="run"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SampleRunCard from '@/components/verification/SampleRunCard.vue'

export default {
  name: 'VerificationRuns',
  components: { SampleRunCard },
  computed: {
    ...mapState({
      sampleRuns: (state) => state.verification.sampleRuns,
    }),
  },
  mounted () {
    this.fetchSampleRuns()
  },
  methods: {
    ...mapActions(['fetchSampleRuns']),
  },
}
</script>
